<template lang="pug">
  .near-color-bar-cta(v-if="nearColorBar" :class="{'ask-a-colorist': chatAvailable}")
    .visit-color-bar.xs-12
      a.visit-btn.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak(href="/colorbar") visit color bar
      button.chat-btn.mr-btn.btn-inverse.xs-f-xsmall.max-at-tweak(v-if="chatAvailable" type="button" @click="$root.openChat") ask a colorist
      
    .more-colorbar-info-wrap.xs-12.text-center
      button.tell-me-more.btn-reset.color-slate.xs-f-small.max-at-tweak(type="button" @click="toggleMoreInfo") Color Bar? Tell me more...
    
      .more-colorbar-info(:class="{open: moreInfoOpen}")
        p.color-white.semi-bold.xs-f-small.max-at-tweak Madison Reed Color Bar
        p.color-white.xs-f-xsmall.max-at-tweak Get your perfect shade applied by a professional colorist. We get you in and out fast, with fabulous results.

</template>

<script>
  export default {
    name: "NearColorBarCTA",

    data() {
      return {
        moreInfoOpen: false
      };
    },

    computed: {
      advisorAnswers() {
        return this.$root.advisorAnswers || {};
      },

      nearColorBar() {
        return this.advisorAnswers.near_colorbar;
      },

      chatAvailable() {
        return this.$root.chatAvailable;
      }
    },

    methods: {
      toggleMoreInfo() {
        this.moreInfoOpen = !this.moreInfoOpen;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .near-color-bar-cta    
    .visit-btn
      width 100%
      
    &.ask-a-colorist
      .visit-btn
      .chat-btn
        width 49%
        
      .chat-btn
        margin-left 2%

      .chat-btn
      .visit-btn
        padding-left 0
        padding-right 0
        text-align center

    .more-colorbar-info-wrap
      text-align center
      padding 1em 0
      
      .more-colorbar-info
        position absolute
        top 100%
        left 50%
        width 22em
        margin-left -11em
        background-color rgba(11, 11, 11, 0.95)
        padding 1em 1.5em
        border-radius 4px
        z-index 10
        text-align left
        opacity 0
        pointer-events none
        transition(opacity 100ms 400ms ease-in-out)
        
        &.open
          opacity 100
          pointer-events initial
        p
          padding-bottom 1em
        
        &:before
          content ''
          position absolute
          width 0
          height 0
          border 0.75em solid transparent
          border-bottom-color rgba(11, 11, 11, 0.95)
          top -1.5em
          left 50%
          margin-left -0.75em
    
</style>
